import React, { Component } from 'react'
import Link from 'gatsby-link'
import Radium from 'radium'
let windowPresent = (typeof window !== 'undefined')
const SideBar = windowPresent ? require('react-fixed-sidebar').default : (<div> </div>)
import HamburgerMenu from 'react-hamburger-menu'

const STYLES = {
  container: {
    position: 'relative',
    height: '100%',
    paddingTop: '30px'
  },
  link: {
    display: 'block',
    textAlign: 'right',
    padding: '10px 35px',
    textTransform: 'uppercase',
    fontSize: '20px',
    textDecoration: 'none',
    fontWeight: 600,
    color: '#6ac2cf'
  },
  footer: {
    position: 'absolute',
    bottom: '30px',
    textAlign: 'center',
    width: '100%'
  },
  sideMenuBtn: {
    position: 'fixed',
    top: 14,
    right: 12,
    zIndex: 2000,
    backgroundColor: 'white',
    borderRadius: 4,
    padding: 8,
    boxShadow: '0 2px 2px rgba(0,0,0,.14)'
  }
}

class MobileMenu extends Component {
  constructor() {
    super()

    this.state = {
      open: false
    }
  }

  handleClick() {
    this.setState({open: !this.state.open})
    this.refs.sidebar.toggle()
  }

  render() {
    const isOpen = this.refs.sidebar
      ? this.refs.sidebar.state.isOpen && this.state.open
      : this.state.open

    return (
      <div>
        <span style={STYLES.sideMenuBtn}>
          <HamburgerMenu
            isOpen={isOpen}
            menuClicked={this.handleClick.bind(this)}
            width={18}
            height={16}
            strokeWidth={1}
            rotate={0}
            color='black'
            borderRadius={0}
            animationDuration={0.32}
          />
        </span>
        <SideBar ref='sidebar'>
          <div style={STYLES.container}>
            <Link style={STYLES.link} to="/">Home</Link>
            <a style={STYLES.link} href={`${process.env.ACCOUNT_SITE_URL}/new`}>Sign Up</a>
            <Link style={STYLES.link} to="/features/">Features</Link>
            <a style={STYLES.link} href="https://share.haiku.ai">Showcase</a>
            <a style={STYLES.link} href="https://docs.haiku.ai" target="_blank">Docs</a>
            <Link style={STYLES.link} to="/blog">Blog</Link>
            <Link style={STYLES.link} to="/pricing">Pricing</Link>
            <a style={STYLES.link} href="mailto:contact@haiku.ai?subject=Hello!">Contact</a>
            <div style={STYLES.footer}>
              <div>© Haiku</div>
              <div>San Francisco, CA</div>
            </div>
          </div>
        </SideBar>
      </div>
    )
  }
}

export default Radium(MobileMenu)



// WEBPACK FOOTER //
// ./src/components/mobile-menu.js